import { useContext } from "react"
import { AuthContext } from "components/authentication/context/authContext"

export function getUserEntity() {
  return useContext(AuthContext).userEntityDetails
}
